export const salesPartyAddressFields = t => [
  [
    'cep',
    t('SALES_PARTIES.FORM.CEP'),
    t('SALES_PARTIES.ADDRESS.CEP_PLACEHOLDER'),
    true,
  ],
  [
    'street',
    t('SALES_PARTIES.FORM.STREET'),
    t('SALES_PARTIES.ADDRESS.STREET_PLACEHOLDER'),
    true,
  ],
  [
    'number',
    t('SALES_PARTIES.FORM.NUMBER'),
    t('SALES_PARTIES.ADDRESS.NUMBER_PLACEHOLDER'),
    true,
  ],
  [
    'unit',
    t('SALES_PARTIES.FORM.UNIT'),
    t('SALES_PARTIES.ADDRESS.UNIT_PLACEHOLDER'),
    false,
  ],
  [
    'complement',
    t('SALES_PARTIES.FORM.COMPLEMENT'),
    t('SALES_PARTIES.ADDRESS.COMPLEMENT_PLACEHOLDER'),
    false,
  ],
  [
    'city',
    t('SALES_PARTIES.FORM.CITY'),
    t('SALES_PARTIES.ADDRESS.CITY_PLACEHOLDER'),
    true,
  ],
  [
    'state',
    t('SALES_PARTIES.FORM.STATE'),
    t('SALES_PARTIES.ADDRESS.STATE_PLACEHOLDER'),
    true,
  ],
  [
    'neighborhood',
    t('SALES_PARTIES.FORM.NEIGHBORHOOD'),
    t('SALES_PARTIES.ADDRESS.NEIGHBORHOOD_PLACEHOLDER'),
    true,
  ],
];
